<template>
<div class="skill">
  <p><slot></slot></p>
  <div class="bar">
    <div class="p_container" :style="percent">
      <div class="progress">
        <span class="lvl">{{level}}%</span>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Skill',
  props: ['level'],
  computed: {
    percent() {
      return { width: `${this.level}%` };
    },
  },
};
</script>

<style lang="scss">
  .skill {
    background: $light_bg;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px 8px 5px;
    margin-top: 8px;
    box-shadow: 0 3px 6px rgba(#000, .15);
    border-radius: 2px;
    cursor: default;
    &:first-child {
      margin-top: 0;
    }
    p {
      color: $text_gray;
      margin: 0;
    }
    .bar {
      width: 100px;
      background: $lightest_bg;
      height: 20px;
      position: relative;
      margin-top: -2.5px;
      .p_container {
        overflow: hidden;
        height: 100%;
        position: relative;
        &:hover {
          .lvl {
            color: $text_gray;
            transform: translate(0);
          }
        }
        .lvl {
          color: transparent;
          position: absolute;
          right: 8px;
          font-size: 15px;
          top: 12%;
          transition: all .2s ease;
          transform: translate(150%);
        }
        .progress {
          height: 100%;
          background: linear-gradient(to right, #1880CF, #449de0);
          overflow: hidden;
          border: 1px solid #0076D1;
          width: 0;
          animation: fill .8s ease .5s forwards;
        }
      }
    }
  }
  @keyframes fill {
    from {
      width: 0;
    }
    to {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/Skill.vue